import { render, staticRenderFns } from "./TermsAndConditionsView.vue?vue&type=template&id=0013a74b&scoped=true&"
import script from "./TermsAndConditionsView.vue?vue&type=script&lang=js&"
export * from "./TermsAndConditionsView.vue?vue&type=script&lang=js&"
import style0 from "./TermsAndConditionsView.vue?vue&type=style&index=0&id=0013a74b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0013a74b",
  null
  
)

export default component.exports